import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { SpinnerChangeEvent } from '../models/spinner-change-event';

@Injectable({ providedIn: 'root' })
export class SpinnerService {
  public mainSpinnerId = 'mainSpinner';
  public spinnerChange: Subject<SpinnerChangeEvent> = new Subject<SpinnerChangeEvent>();

  public show(
    spinnerId: string,
    failureMsg?: string,
    timeoutInSec?: number,
    progressMessageHeader?: string,
    progressMessage?: string,
    needProgressMessage: boolean = false): void {
    const options = {
      visible: true,
      spinnerId,
      failureMsg,
      timeoutInSec,
      progressMessageHeader,
      progressMessage,
      needProgressMessage
    };
    this.spinnerChange.next(options);
  }

  public hide(spinnerId: string): void {
    this.spinnerChange.next({ visible: false, spinnerId });
  }
}
